module.exports = __webpack_public_path__ + "media/images/icon/lock-465e39e8fbd176810b4553aab7a5ddbf.svg";